import { Component, Inject, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MacAddressService } from '../../services/mac-address.service';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NgxPrintService } from 'ngx-print';
import { ErrorMessagePipe } from '../../pipes/error-message.pipe';
import { NgFor, NgIf, UpperCasePipe } from '@angular/common';

@Component({
  selector: 'dl-mac-address-result-modal',
  templateUrl: './mac-address-result-modal.component.html',
  styleUrl: './mac-address-result-modal.component.scss',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  // Removed ErrorMessagePipe from imports as it is not standalone
  imports: [ErrorMessagePipe, UpperCasePipe, NgIf, NgFor]
})
export class MacAddressResultModalComponent {

  
  public macAddressTableColumns: string[] = ['serialNumber', 'mac-address'];
  public dataSource = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any[], private ngxService : NgxPrintService,
    private addressService: MacAddressService, private dialog : MatDialog) {
  }

  ngOnInit(): void {
    this.dataSource = this.data;
  }

  public copyToClipboard(): void {
    const clipboardData = this.addressService.prepareDataForCopyToClipboard(this.data);
    navigator.clipboard.writeText(clipboardData);
  }

  public printPage() : void {
    const customPrintOptions = {
        printSectionId: 'print-section',
        printTitle: "Liat Mac Address",
        useExistingCss: true,
        bodyClass : '',
        openNewTab : false,
        previewOnly : false,
        closeWindow : true,
        printDelay : 0
    };
    this.ngxService.print(customPrintOptions);
  }

  public closePopup(): void {
    this.dialog.closeAll();
  }
}
